import axiosInstance from "./AxiosInstance";

// List forms
export function getAssignedLeadHistory(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = "",
  status = "",
) {
  return axiosInstance.post("/lead/leadAssignedHistory", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
    status,
  });
}

export function formatAssignedHistory(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((item) => ({
      lead_history_id: item.lead_history_id,
      lead_id: item.lead_id,
      full_name:
      item.full_name?.trim() ||
      `${item.first_name || ""} ${item.last_name || ""}`.trim() ||
      "-",
      telecaller_name: item.telecaller_name || "-",
      lead_type: item.lead_type || "-",
      date: item.updated_at || "",
      is_converted_status: item.is_converted_status || "Not Converted",
      questionnaire_filled: item.questionnaire_filled || "No",
      patient_id: item.patient_id || null,
      diseases: Array.isArray(item.diseases) ? item.diseases : [],
    }));
  }

  return [];
}